/**
 * Bootstrap for the SPA's i18n system: registers the built-in catalogues
 * so `useT()` / `translate()` can find them. Called once from main.tsx
 * before the first render.
 *
 * Two locales ship today: en-GB (source of truth) and id-ID (Bahasa
 * Indonesia). Adding a new locale is a JSON file + a `registerCatalogue`
 * call here.
 */
import enGB from "../i18n/en-GB.json";
import idID from "../i18n/id-ID.json";
import { registerCatalogue, type TranslationCatalogue } from "./i18n";

let registered = false;

export function bootstrapI18n(): void {
  if (registered) return;
  registerCatalogue("en-GB", enGB as TranslationCatalogue);
  registerCatalogue("id-ID", idID as TranslationCatalogue);
  registered = true;
}
